import { Box, Tooltip } from '@mui/material'
import { getLocalFormattedDateTimeFromUTCString } from 'src/utils/function'

export const diffMinutes = (from?: string, to?: string): number => {
  if (!from || !to) return 0
  const ms = new Date(to).getTime() - new Date(from).getTime()
  if (Number.isNaN(ms)) return 0
  return Math.max(0, Math.floor(ms / 60000))
}

export const formatHoursMinutes = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return `${hours}h ${minutes.toString().padStart(2, '0')}m`
}

export const formatDuration = (from?: string, to?: string): string =>
  formatHoursMinutes(diffMinutes(from, to))

export const DateTimeStackCell: React.FC<{ value?: string }> = ({ value }) => {
  if (!value) return <>-</>
  return (
    <Box display="flex" flexDirection="column" lineHeight={1.2}>
      <span>{getLocalFormattedDateTimeFromUTCString(value, 'HH:mm')}</span>
      <span style={{ fontSize: '0.8em', opacity: 0.6 }}>
        {getLocalFormattedDateTimeFromUTCString(value, 'YYYY-MM-DD')}
      </span>
    </Box>
  )
}

export const DurationCell: React.FC<{ from?: string; to?: string }> = ({ from, to }) => (
  <span>{formatDuration(from, to)}</span>
)

export const MultilineCell: React.FC<{ value?: string; maxLines?: number }> = ({
  value,
  maxLines,
}) => {
  const content = (
    <Box
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: 1.3,
        py: 0.5,
        width: '100%',
        ...(maxLines
          ? {
              display: '-webkit-box',
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }
          : {}),
      }}
    >
      {value ?? ''}
    </Box>
  )
  if (!maxLines || !value) return content
  return (
    <Tooltip title={value} placement="top-start" enterDelay={300}>
      {content}
    </Tooltip>
  )
}

export const PlacementCell: React.FC<{ localityName?: string; taskTitle?: string }> = ({
  localityName,
  taskTitle,
}) => {
  const parts = [localityName, taskTitle].filter(Boolean)
  if (parts.length === 0) return <MultilineCell value="-" />
  return <MultilineCell value={parts.join(' → ')} />
}
